/**
 * Registers a directive for CMS preference multiselect functionality.
 * @param {Object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerCmsPreferenceMultiselectDirective(module) {
    module.directive('cmsPreferenceMultiselect', function($compile, $bridges, TaskDataService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                theKey: '=key',
                prefData: '=data',
                parentScope: '=scope',
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-multiselect.html",
            controller: ['$injector', '$scope', '$rootScope', '$signals', '$interval', class {
                /**
                 * Controller for the cmsPreferenceMultiselect directive.
                 * @param {Object} $injector - AngularJS injector service.
                 * @param {Object} $scope - AngularJS scope service.
                 * @param {Object} $rootScope - AngularJS root scope service.
                 * @param {Object} $signals - Custom signals service.
                 * @param {Object} $interval - AngularJS interval service.
                 */
                constructor($injector, $scope, $rootScope, $signals, $interval) {
                    this.$injector = $injector;
                    this.$scope = $scope;
                    this.$rootScope = $rootScope;
                    this.$signals = $signals;
                    this.$interval = $interval;

                    // Initialize data from the scope
                    this.$scope.data = this.$scope.prefData[this.$scope.theKey];
                    // Generate a random ID for the element
                    this.$scope.randomId = angular.createUUID();
                    // Set the size from the parent scope
                    this.$scope.size = this.$scope.parentScope.$parent.$parent.size;

                    // SMELL: Deep scope traversal (this.$scope.parentScope.$parent.$parent) can be error-prone and hard to maintain.
                    // Consider refactoring to a more direct or explicit method of data retrieval.
                }
            }]
        };
    });
}